import { render, staticRenderFns } from "./BudgetsIndex.vue?vue&type=template&id=0bbf1657&scoped=true"
import script from "./BudgetsIndex.vue?vue&type=script&lang=js"
export * from "./BudgetsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf1657",
  null
  
)

export default component.exports